import { PropTypes } from 'react';

const communityContentIdObject = PropTypes.shape({
  type: PropTypes.number.isRequired,
  relatedId: PropTypes.string.isRequired,
  secondaryRelatedId: PropTypes.string,
});

const communityContentShareData = PropTypes.shape({
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  ownerType: PropTypes.number,
  ownerId: PropTypes.string,
  tweetText: PropTypes.string,
});

const feedUserId = PropTypes.shape({
  type: PropTypes.number.isRequired,
  relatedId: PropTypes.string.isRequired,
});

const feedItem = PropTypes.shape({
  feedContentId: PropTypes.string.isRequired,
  isSponsored: PropTypes.bool.isRequired,
});

const userDetails = PropTypes.shape({
  feedUserId: feedUserId.isRequired,
  followersCount: PropTypes.number,
  formattedPositions: PropTypes.string,
  imageUrl: PropTypes.string.isRequired,
  jersey: PropTypes.string,
  name: PropTypes.string.isRequired,
  positions: PropTypes.arrayOf(PropTypes.string),
  school: PropTypes.string,
  schoolLocation: PropTypes.string,
  schoolName: PropTypes.string,
  sportId: PropTypes.string,
  url: PropTypes.string,
});

const feedUserProps = {
  feedUserId: feedUserId.isRequired,
  followersCount: PropTypes.number,
  friendsCount: PropTypes.number,
  profilePictureUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

const feedUser = PropTypes.shape({
  ...feedUserProps,
});

const feedUserSearchResult = PropTypes.shape({
  ...feedUserProps,
  searchPosition: PropTypes.number.isRequired,
  score: PropTypes.number,
  isFollowing: PropTypes.bool.isRequired,
  views: PropTypes.number.isRequired,
  description: PropTypes.string,
  primaryTeam: PropTypes.shape({
    jersey: PropTypes.string,
    positions: PropTypes.arrayOf(PropTypes.string),
    primaryColor: PropTypes.string,
    schoolName: PropTypes.string,
    teamName: PropTypes.string,
    location: PropTypes.string,
    sportId: PropTypes.number,
  }),
  primaryColor: PropTypes.string,
  schoolName: PropTypes.string,
  teamName: PropTypes.string,
  location: PropTypes.string,
  sportId: PropTypes.number,
});

const storeShape = PropTypes.shape({
  subscribe: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  getState: PropTypes.func.isRequired,
});

const discoveryTimeline = PropTypes.shape({
  timelineType: PropTypes.number.isRequired,
  translationKey: PropTypes.string.isRequired,
  timelineKey: PropTypes.string.isRequired,
  sport: PropTypes.number,
  containerSection: PropTypes.string.isRequired,
});

const adTag = PropTypes.shape({
  vastTag: PropTypes.string.isRequired,
  mobileVastTag: PropTypes.string.isRequired,
  preRollAdData: PropTypes.object.isRequired,
});

export {
  communityContentIdObject, communityContentShareData, feedUserId, feedItem,
  userDetails, feedUser, feedUserSearchResult, storeShape, discoveryTimeline,
  adTag,
};
